import { render, staticRenderFns } from "./dialAssignItem.vue?vue&type=template&id=3ea62e0c&"
import script from "./dialAssignItem.vue?vue&type=script&lang=js&"
export * from "./dialAssignItem.vue?vue&type=script&lang=js&"
import style0 from "./dialAssignItem.vue?vue&type=style&index=0&id=3ea62e0c&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports